
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class SubCategoryMasterDialog extends Serenity.EntityDialog<SubCategoryMasterRow, any> {
        protected getFormKey() { return SubCategoryMasterForm.formKey; }
        protected getIdProperty() { return SubCategoryMasterRow.idProperty; }
        protected getLocalTextPrefix() { return SubCategoryMasterRow.localTextPrefix; }
        protected getNameProperty() { return SubCategoryMasterRow.nameProperty; }
        protected getService() { return SubCategoryMasterService.baseUrl; }
        protected getInsertPermission() { return SubCategoryMasterRow.insertPermission; }
        protected getUpdatePermission() { return SubCategoryMasterRow.updatePermission; }
        protected getDeletePermission() { return SubCategoryMasterRow.deletePermission; }
        protected useViewMode() { return true; }

        protected form = new SubCategoryMasterForm(this.idPrefix);

        constructor() {
            super();
            this.form.ItemTypeId.changeSelect2(e => {
                this.form.Details.cascadeField = "ItemTypeId";
                this.form.Details.cascadeValue = this.form.ItemTypeId.value;
                if (this.form.ItemTypeId.value == "105")
                    q.showAndSetRequiredField(this.form.PointerWeight)
                else
                    q.hideField(this.form.PointerWeight)

            })
            this.form.SubCategoryCode.changeSelect2(e => {
                var id = SubCategoryMasterRow.getLookup().items.filter(x => x.SubCategoryCode.toUpperCase() == this.form.SubCategoryCode.value.toUpperCase())[0];
                if (id != undefined) {
                    if (id.SubCategoryId != null || id.SubCategoryId > 0) {
                        Q.notifyError("Duplicate Sub Category " + this.form.SubCategoryCode.value);
                        this.form.SubCategoryCode.value = "";
                        return;
                    }
                }
                else {
                    this.form.SubCategoryCode.value = this.form.SubCategoryCode.value.toUpperCase();
                }
            })
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };

            return btns;
        }

        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            //var id = SubCategoryMasterRow.getLookup().items.filter(x => x.SubCategoryName == this.form.SubCategoryName.value)[0];
            //var refid = CommonAttributesRow.getLookup().items.filter(x => x.SubCategoryId == id.SubCategoryId)[0];
            var refid: Common.CommonAttributeResponse;
            OMS.CommonAttributesService.GetProductATB({
                SubCategoryId: this.entityId
            }, response => {
                refid = response;
            }, { async: false });
            if (refid.AttributeId > 0) {
                if (refid.AttributeId != null || refid.AttributeId > 0) {
                    Q.alert("Sub Category is in use, Cannot delete");
                    return;
                }
            } else {
                SubCategoryMasterService.Delete(
                    {

                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.ItemTypeId.value != "")
                if (this.form.ItemTypeId.value == "105")
                    q.showAndSetRequiredField(this.form.PointerWeight)
                else
                    q.hideField(this.form.PointerWeight)
        }
    }
}